import React, { useMemo, useState } from 'react';
import { ListChecksIcon } from 'lucide-react';
import { PageHeader } from '../components/layout/PageHeader';
import { FAB } from '../components/ui/FAB';
import { EmptyState } from '../components/ui/EmptyState';
import { TaskItem } from '../components/tasks/TaskItem';
import { AddTaskSheet } from '../components/tasks/AddTaskSheet';
import { useAppData } from '../contexts/AppDataContext';
export function Tasks() {
  const {
    tasks,
    addTask,
    toggleTaskCompleted,
    deleteTask
  } = useAppData();
  const [isAddOpen, setIsAddOpen] = useState(false);
  const {
    pending,
    completed
  } = useMemo(() => {
    const sorted = [...tasks].sort((a, b) => new Date(a.deadline).getTime() - new Date(b.deadline).getTime());
    return {
      pending: sorted.filter(t => !t.completed),
      completed: sorted.filter(t => t.completed)
    };
  }, [tasks]);
  return <div className="relative flex h-full flex-col" data-id="element-181" data-mp="2xb6zkcz2rukc">
      <PageHeader title="Tasks" subtitle={pending.length ? `${pending.length} pending` : 'Nothing pending — nice work'} data-id="element-182" data-mp="2x9dtaysdjccv" />
      <div className="flex-1 space-y-3 overflow-y-auto px-5 py-4 pb-28" data-id="element-183" data-mp="1wivs0t0to4ii">
        {tasks.length === 0 ? <EmptyState icon={ListChecksIcon} title="No tasks yet" description="Add one to start tracking deadlines." data-id="element-184" data-mp="21hp3kfwjtlg1" /> : <>
            {pending.map(task => <TaskItem key={task.id} task={task} onToggleComplete={() => toggleTaskCompleted(task.id)} onDelete={() => deleteTask(task.id)} data-id="element-185" data-mp="1rnyh1gjzfl2z" />)}
            {completed.length > 0 && <div className="pt-2" data-id="element-186" data-mp="13xufrfu9nxf5">
                <p className="mb-2 px-1 text-xs font-semibold uppercase tracking-wide text-slate-400" data-id="element-187" data-mp="18vdsgbbbg24z">Completed</p>
                <div className="space-y-3" data-id="element-188" data-mp="uvuzipr2sxd9">
                  {completed.map(task => <TaskItem key={task.id} task={task} onToggleComplete={() => toggleTaskCompleted(task.id)} onDelete={() => deleteTask(task.id)} data-id="element-189" data-mp="yx6msomh96ia" />)}
                </div>
              </div>}
          </>}
      </div>
      <FAB label="Add task" onClick={() => setIsAddOpen(true)} colorClassName="bg-indigo-600 hover:bg-indigo-700" data-id="element-190" data-mp="2rubqd0cq57wy" />
      <AddTaskSheet isOpen={isAddOpen} onClose={() => setIsAddOpen(false)} onSubmit={addTask} data-id="element-191" data-mp="2msw79du3xbh7" />
    </div>;
}